import envVariables from '../../consts/envVariables';
import {createClient} from '../dam/damClient';
import uamClientError from './uamClientError';

const createHeaders = (token) => ({
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
});

const uamClient = createClient({
    defaultEndpoint: envVariables.INC_CLOUD_API_ENDPOINT,
    createHeaders,
    clientError: uamClientError,
    logPrefix: 'uamClient',
});

// inject client into error handler to break circular dependency
uamClientError.setClient(uamClient);

export default uamClient;
